import { render, staticRenderFns } from "./zean.vue?vue&type=template&id=70ff53a8&scoped=true&"
import script from "./zean.vue?vue&type=script&lang=js&"
export * from "./zean.vue?vue&type=script&lang=js&"
import style0 from "./zean.vue?vue&type=style&index=0&id=70ff53a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ff53a8",
  null
  
)

export default component.exports